import React from "react";
import "../../../../../css/pages/ca_pages/teams/employees_model/EmployeeToolbar.css";

const TaskToolbar = ({
    filters,
    onSearchChange,
    onStatusChange,
    onPriorityChange,
    onReset,
    taskCount,
    totalCount,
    loading,
}) => {
    return (
        <div className="employee-toolbar">
            <div className="employee-toolbar-top">
                <div className="employee-search">
                    <span>🔍</span>

                    <input
                        type="text"
                        value={filters.search}
                        onChange={(event) =>
                            onSearchChange(event.target.value)
                        }
                        placeholder="Search tasks..."
                    />
                </div>
            </div>

            <div className="employee-toolbar-bottom">
                <div className="employee-filters">

                    <select
                        value={filters.status}
                        onChange={(event) =>
                            onStatusChange(event.target.value)
                        }
                    >
                        <option value="">
                            Status
                        </option>

                        <option value="pending">
                            Pending
                        </option>

                        <option value="in_progress">
                            In Progress
                        </option>

                        <option value="paused">
                            Paused
                        </option>

                        <option value="review">
                            Review
                        </option>

                        <option value="completed">
                            Completed
                        </option>

                        <option value="cancelled">
                            Cancelled
                        </option>
                    </select>

                    <select
                        value={filters.priority}
                        onChange={(event) =>
                            onPriorityChange(event.target.value)
                        }
                    >
                        <option value="">
                            Priority
                        </option>

                        <option value="low">
                            Low
                        </option>

                        <option value="medium">
                            Medium
                        </option>

                        <option value="high">
                            High
                        </option>

                        <option value="critical">
                            Critical
                        </option>
                    </select>

                    <button
                        type="button"
                        className="reset-btn"
                        onClick={onReset}
                    >
                        Reset
                    </button>
                </div>

                <div className="employee-count">
                    {loading ? (
                        "Loading tasks..."
                    ) : (
                        <>
                            Showing{" "}
                            <strong>
                                {taskCount}
                            </strong>{" "}
                            of{" "}
                            <strong>
                                {totalCount}
                            </strong>{" "}
                            Tasks
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TaskToolbar;
